import { type App, type DirectiveBinding } from 'vue'
import emitter from './mitt'
import { ElNotification } from 'element-plus'
import { isEqual } from 'lodash'
import login from '@/components/login'

interface wordSelection {
  oneWord?: boolean
  text: string
  termName?: string
  onSelectWord?: (word: string) => void
}

export default function myDirective(app: App<Element>) {
  app.directive('word-selection', (el: HTMLDivElement, binding) => {
    const value = binding.value as wordSelection | undefined
    // 判断oneWord和text是否被改变
    if (value && binding.oldValue) {
      // 判断对象值是否相等
      if (isEqual(binding.oldValue, binding.value)) {
        return
      }
    }
    if (value?.oneWord) {
      selectWord(el, binding)
    } else {
      wordParaphrase(el, binding)
    }
  })
  app.directive('auth-login', (el: HTMLDivElement, binding) => {
    el.onclick = () => {
      if (Boolean(localStorage.getItem('token'))) {
        binding.value()
      } else {
        login()
      }
    }
  })
  app.directive('auto-width', {
    beforeMount(el) {
      // 创建一个隐藏的测试元素，用来测量文本宽度
      let tester = document.createElement('div')
      tester.style.position = 'absolute'
      tester.style.visibility = 'hidden'
      tester.style.fontSize = '18px'

      document.body.appendChild(tester)
      let adjustWidth = () => {
        // 将输入框的内容设置到测试元素中，并获取其宽度
        tester.textContent = el.value
        let width = tester.getBoundingClientRect().width

        // 将宽度应用到输入框上，添加一点额外的空间以防止文字紧贴输入框边缘
        el.style.width = `${width}px`
      }

      // 首次绑定时调整一次宽度
      adjustWidth()

      // 在输入事件上添加监听器，动态调整宽度
      el.addEventListener('input', adjustWidth)

      // 在卸载元素时移除监听器和测试元素
      el._destroyAutoWidth = () => {
        el.removeEventListener('input', adjustWidth)
        document.body.removeChild(tester)
      }
    },
    beforeUnmount(el) {
      // 调用在 beforeMount 阶段保存的销毁函数
      el._destroyAutoWidth()
    }
  })
}

// 选词模式
function selectWord(el: HTMLDivElement, binding: DirectiveBinding<wordSelection>) {
  el.classList.add('one-word')
  let wordIdx = 0
  const html = binding.value.text
    .split(' ')
    .map((item) => {
      if (isSymbol(item)) {
        return `<span  class="word symbol">${item}</span>`
      } else {
        wordIdx += 1
        return `<span data-index="${wordIdx}" class="word">${item}</span>`
      }
    })
    .join('')
  el.innerHTML = html
  let st = -1
  let end = -1
  el.onclick = (event) => {
    const wordDom = event.target as HTMLSpanElement

    if (wordDom.nodeName === 'SPAN' && wordDom.className.indexOf('word') !== -1) {
      const wordDomIndex = Number(wordDom.dataset.index)
      if (st === -1 || (st !== -1 && end !== -1)) {
        st = wordDomIndex
        end = -1
      } else if (end === -1) {
        end = wordDomIndex
        // 限制选词不能少于10个
        if (Math.abs(st - wordDomIndex) < 10 - 1) {
          st = wordDomIndex
          ElNotification({
            offset: 100,
            title: '一句话模式使用',
            message: '点击想选句子首位和末尾单词进行练习，最少选10个词'
          })
        }
      }

      ;[...el.querySelectorAll('.word')].forEach((item) => {
        item.classList.remove('st', 'end', 'active')
      })
      ;[...el.querySelectorAll('.word')].forEach((item) => {
        const idx = Number((item as HTMLSpanElement).dataset.index)
        if (idx === st) {
          item.classList.add('st')
        }
        if (idx === end) {
          item.classList.add('end')
        }
      })

      if (st !== -1 && end !== -1) {
        let c = -1
        if (end < st) {
          c = end
          end = st
          st = c
          const stDom = el.querySelector('.word.st')
          const endDom = el.querySelector('.word.end')
          stDom?.classList.remove('st')
          stDom?.classList.add('end')
          endDom?.classList.remove('end')
          endDom?.classList.add('st')
        }
        ;[...el.querySelectorAll('.word')].forEach((item) => {
          const idx = Number((item as HTMLSpanElement).dataset.index)
          if (idx >= st && idx <= end) {
            item.classList.add('active')
          }
        })
        ;[...el.querySelectorAll('.symbol')].forEach((item) => {
          if (
            item.previousElementSibling?.classList.contains('active') &&
            item.nextElementSibling?.classList.contains('active')
          ) {
            item.classList.add('active')
          }
        })
        const selectTex = ([...el.querySelectorAll('.word.active')] as HTMLSpanElement[])
          .map((item) => item.innerText + ' ')
          .join('')
        binding.value.onSelectWord && binding.value.onSelectWord(selectTex)
      }
    }
  }
}

// 单词释义模式
function wordParaphrase(el: HTMLDivElement, binding: DirectiveBinding<wordSelection>) {
  var Regx = /^[A-Za-z0-9]/
  if (!binding.value.text) return
  var content = binding.value.text
  content = content
    .replace(/&rsquo;/g, "'")
    .replace(/&nbsp;|0xA0/g, ' ')
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&')
  var messageCon = content.split(/(<[^>]+>)/g)
  var DataS = []
  for (let info of messageCon) {
    if (info.search(/(<[^>]+>)/g) < 0) {
      // 先将所有的 HTML 实体替换为占位符
      const placeholder = 'HTMLENTITYPLACEHOLDER'
      const entityRegex = /&[a-z]+;/g

      const entities: string[] = []
      const tempInfo = info.replace(entityRegex, (match) => {
        entities.push(match)
        return placeholder
      })

      // 替换普通单词
      const wordRegex = /\b[\w']+\b/g
      const intermediateResult = tempInfo.replace(wordRegex, `<span class="word">$&</span>`)

      // 将占位符再替换回原来的 HTML 实体
      let entityIndex = 0
      const finalResult = intermediateResult.replace(
        new RegExp(placeholder, 'g'),
        () => entities[entityIndex++]
      )
      info = finalResult
    }
    DataS.push(info)
  }
  el.id = 'word-selection'
  el.classList.remove('one-word')
  el.innerHTML = DataS.join('')
  el.innerHTML = el.innerHTML
    .replace(/&rsquo;/g, "'")
    .replace(/&nbsp;|0xA0/g, ' ')
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&')

  el.onclick = (event) => {
    const wordDom = event.target as HTMLSpanElement
    if (
      wordDom.nodeName === 'SPAN' &&
      wordDom.className.indexOf('word') !== -1 &&
      wordDom.className.indexOf('symbol') === -1 //不为符号
    ) {
      if (Regx.test(wordDom.innerText)) {
        console.log('wordParaphrase termName:' + binding.value.termName)
        emitter.emit('word', {
          wordStr: wordDom.innerText,
          termName: binding.value.termName ? binding.value.termName : ''
        })
      }
    }
  }
}
export function wordCount(text: string) {
  return text
    .replace(/(--|\s+)/g, ' ')
    .trim()
    .split(' ')
    .filter((item) => item).length
}
function isSymbol(str: string) {
  var pattern = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/
  return pattern.test(str)
}
